import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../general/Tooltip';
import './styles.css';

/*
 * One action at the end of a table row.
 *
 * These were bare icons in a <span> - nothing under the pointer changed, so
 * there was no way to tell a picture from a button until you clicked one. This
 * is a real button: a square that fills on hover, takes the keyboard, and says
 * what it does through a tooltip.
 *
 * The icon is handed in rather than coloured by the caller: the button sets the
 * colour, so the row's actions match each other and the danger ones stand out.
 */
const TableAction = ({icon, tooltip, onClick, tone, disabled}) => {
    const button = (
        <button
            type="button"
            className={'table-action table-action--' + tone}
            disabled={disabled}
            onClick={(event) => {
                /* the row itself opens the conversation; an action is not that */
                event.stopPropagation();
                onClick(event);
            }}
        >
            {icon}
        </button>
    );

    if (!tooltip) return button;

    return (
        <Tooltip
            deltaY={-7}
            text={tooltip}
            disabled={disabled}
            style={{display: 'inline-flex', width: 'fit-content'}}
        >
            {button}
        </Tooltip>
    );
};

TableAction.propTypes = {
    /* drawn in currentColor, so it takes the button's own state */
    icon: PropTypes.node.isRequired,
    tooltip: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    tone: PropTypes.oneOf(['default', 'danger']),
    disabled: PropTypes.bool,
};

TableAction.defaultProps = {
    tone: 'default',
    disabled: false,
};

export default TableAction;



// WEBPACK FOOTER //
// ./src/components-new/table/TableAction/index.jsx